module.exports = __webpack_public_path__ + "static/media/logo.3ba09941.png";